import React from 'react';
import { Route } from 'react-router-dom';
import SupportMessage from './index';

export default <Route path="/homepage/support" component={SupportMessage} />;
